/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import { TotalTabWrap } from '@styles/base.style'
import { Tabs } from 'antd-mobile'
import { Models } from 'rmc-tabs/lib/Models'
import { CommentActivityContent } from './CommentActivityContent'
import useRootStore from '@store/useRootStore'
import { useOnUnmount } from '@utils/reactExt'
import { FROM_VIEW_TYPE, USER_COMMENT_TYPE } from '@v2/constants/common'
import _ from 'lodash'

enum USER_ACTIVITY_TAB_KEY {
  USER_PICK_COMMENT = 'user-pick-comment',
  COMPANY_PICK_COMMENT = 'company-pick-comment',
}

export interface CommentActivityProps {
  initTabIndex?: number
  baseMonth?: string
}

export const CommentActivity: React.FC<CommentActivityProps> = observer((props) => {
  const { userPickStore, userStore } = useRootStore()
  const { initTabIndex = 0, baseMonth } = props
  const [currentTabKey, setCurrentTabKey] = useState(
    initTabIndex === 0 ? USER_ACTIVITY_TAB_KEY.USER_PICK_COMMENT : USER_ACTIVITY_TAB_KEY.COMPANY_PICK_COMMENT,
  )
  const { myActivity } = userStore

  useOnUnmount(() => {
    userPickStore.resetUserPickMine()
  })

  const pickCommentCount
    = _.isNil(baseMonth) ? myActivity?.totalUserPickCommentCount : myActivity?.monthlyUserPickCommentCount
  const companyPickCommentCount
    = _.isNil(baseMonth) ? myActivity?.totalCompanyPickCommentCount : myActivity?.monthlyCompanyPickCommentCount

  const userActivityTabList = [
    {
      title: (
        <span className="tab-item large-txt">
            <span className="txt">나도 승부사 댓글</span>
            <span className="num">{pickCommentCount}</span>
          </span>
      ),
      name: '나도 승부사',
      key: USER_ACTIVITY_TAB_KEY.USER_PICK_COMMENT,
    },
    {
      title: (
        <span className="tab-item large-txt">
            <span className="txt">프리미엄 분석가 댓글</span>
            <span className="num">{companyPickCommentCount}</span>
          </span>
      ),
      name: '프리미엄 분석가 댓글',
      key: USER_ACTIVITY_TAB_KEY.COMPANY_PICK_COMMENT,
    },
  ]

  const onChange = (tab: Models.TabData) => {
    setCurrentTabKey(tab.key as USER_ACTIVITY_TAB_KEY)
  }

  let contents
  switch (currentTabKey) {
    case USER_ACTIVITY_TAB_KEY.USER_PICK_COMMENT:
      contents = (
        <CommentActivityContent
          key={'user_pick_comment_activity'}
          commentType={USER_COMMENT_TYPE.USER_PICK_COMMENT}
          fromViewType={FROM_VIEW_TYPE.USER_PICK_COMMENT}
          baseMonth={baseMonth}
          disableUserDetailInfo
        />
      )
      break
    case USER_ACTIVITY_TAB_KEY.COMPANY_PICK_COMMENT:
      contents = (
        <CommentActivityContent
          key={'company_pick_comment_activity'}
          commentType={USER_COMMENT_TYPE.COMPANY_PICK_COMMENT}
          fromViewType={FROM_VIEW_TYPE.COMPANY_PICK_COMMENT}
          baseMonth={baseMonth}
          disableUserDetailInfo
        />
      )
      break
  }

  return (
    <Fragment>
      <TotalTabWrap underline>
        <Tabs
          tabs={userActivityTabList}
          initialPage={initTabIndex}
          page={currentTabKey}
          onChange={onChange}
        />
      </TotalTabWrap>
      {contents}
    </Fragment>
  )
})
